<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- IE 2026 08 21 (заказ Игоря): выключенные (use=false) плитки скрываются
             целиком; при нечётном числе оставшихся последняя — на всю ширину -->
        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
        <div class="grid-container" :class="{ 'tiles-odd': visibleTilesCount() % 2 === 1 }">
            <div class="button grid-item grid-item-green" @click="onClick({'addon':'ADDON_sales'})"
                v-if="isAvailable('ADDON_sales')"
                v-wjTooltip="t('Multifactor AI and Statistical Demand Forecasting')"
            >
                <h2 class="m-0">{{ t('SALES') }}</h2>
                <i v-if="wsIco('images/icon-DEMAND-FORECASTING.png')" :class="['img-func img-func-ico', wsIco('images/icon-DEMAND-FORECASTING.png')]"></i><img v-else class="img-func" src="images/icon-DEMAND-FORECASTING.png" data-mimetype="image/png">
            </div>
            <div class="button grid-item grid-item-blue" @click="onClick({'addon':'ADDON_manufacturing'})"
                v-if="isAvailable('ADDON_manufacturing')"
                v-wjTooltip="t('Material requirements planning for production')"
            >
                <h2 class="m-0">{{ t('MANUFACTURING') }}</h2>
                <i v-if="wsIco('images/icon-MANUFACTURING-PLANNER.png')" :class="['img-func img-func-ico', wsIco('images/icon-MANUFACTURING-PLANNER.png')]"></i><img v-else class="img-func" src="images/icon-MANUFACTURING-PLANNER.png" data-mimetype="image/png">
            </div>

            <div class="button grid-item grid-item-blue" @click="onClick({'addon':'ADDON_inventory_optimizer'})"
                v-if="isAvailable('ADDON_inventory_optimizer')"
                v-wjTooltip="t('Replenishment planning, optimal stock levels')"
            >
                <i v-if="wsIco('images/icon-INVENTORY-OPTIMIZER.png')" :class="['img-func img-func-ico', wsIco('images/icon-INVENTORY-OPTIMIZER.png')]"></i><img v-else class="img-func" src="images/icon-INVENTORY-OPTIMIZER.png" data-mimetype="image/png">
                <h2 class="m-0">{{ t('DISTRIBUTION') }}</h2>
            </div>
            <div class="button grid-item grid-item2 grid-item-green" @click="onClick({'addon':'ADDON_purchase'})"
                v-if="isAvailable('ADDON_purchase')"
                v-wjTooltip="''"
            >
                <i v-if="wsIco('images/icon-INVENTORY-OPTIMIZER.png')" :class="['img-func img-func-ico', wsIco('images/icon-INVENTORY-OPTIMIZER.png')]"></i><img v-else class="img-func" src="images/icon-INVENTORY-OPTIMIZER.png" data-mimetype="image/png">
                <h2 class="m-0">{{ t('PURCHASE') }}</h2>
            </div>
            
            <div class="button grid-item grid-item2 grid-item-green" @click="onClick({'addon':'ADDON_data'})"
                v-if="isAvailable('ADDON_data')"
                v-wjTooltip="t('The core set of data that is essential and shared across the various systems and processes within an organization. It includes key entities such as customers, products, employees, and suppliers.')"
            >
                <i v-if="wsIco('images/icon-master-data.png')" :class="['img-func img-func-ico', wsIco('images/icon-master-data.png')]"></i><img v-else class="img-func" src="images/icon-master-data.png" data-mimetype="image/png">
                <h2 class="m-0">{{ t('WORK DATA') }}</h2>
            </div>
            <div class="button grid-item grid-item2 grid-item-blue" @click="onClick({'addon':'ADDON_data_hub'})"
                v-if="isAvailable('ADDON_data_hub')"
                v-wjTooltip="t('Connectors to external ERP, WMS, or Accounting systems')"
            >
                <i v-if="wsIco('images/icon-DATA-HUB.png')" :class="['img-func img-func-ico', wsIco('images/icon-DATA-HUB.png')]"></i><img v-else class="img-func" src="images/icon-DATA-HUB.png" data-mimetype="image/png">
                <h2 class="m-0">{{ t('DATA HUB') }}</h2>
            </div>
            
            <div class="button center-circle" @click="onClick({'addon':'ADDON_finance'})"
                v-if="isAvailable('ADDON_finance')"
                v-wjTooltip="t('Sales & Operations Planning')"
            >
                <i v-if="wsIco('images/icon-process-model.png')" :class="['img-func2 img-func2-ico', wsIco('images/icon-process-model.png')]"></i><img v-else class="img-func2" src="images/icon-process-model.png" data-mimetype="image/png">
                <h2 class="m-0">{{ t('S&OP') }}</h2>
                <!-- <h2 class="logo">WebSCM</h2> -->
                <!-- <div class="p-logo">& analysis tools</div> -->
            </div>
            <img class="img-gear" v-if="isAvailable('ADDON_finance')" src="images/icon-gear.png" data-mimetype="image/png">
        </div>
    </Attr>
</template>
  
  <script>
//<template>
//     <Attr :widget_id="widget_id" :attr_id="attr_id">
//         <!-- <div :ref="container"/> -->
//     </Attr>
// </template>

// import { defineComponent } from 'vue';
// export default defineComponent({
//   template: `<h3>Leave3333 blank to automatically generate the default view</h3>`,
// });

import { useMainStore } from '@/stores/mainStore'
import { wsIconClass } from '@/utils/wsIcons'   // IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили)

export default {
    props: [
        'widget_id',
        'attr_id',
    ],
    // template: `<h3>Leave3333 blank to automatically generate the default view</h3>`,
    data: () => ({ 
        WIDGET: {},
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
    },
    methods: {
        // IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили): картинка плитки → глиф текущей схемы иконок (Classic — картинка)
        wsIco(img) { return wsIconClass(img, this.store?.iconScheme) },
        visibleTilesCount() {
            return ['ADDON_sales', 'ADDON_manufacturing', 'ADDON_inventory_optimizer',
                'ADDON_purchase', 'ADDON_data', 'ADDON_data_hub']
                .filter(a => this.isAvailable(a)).length
        },
        content_Changed() {
            this.store.widget_attr_set(this)
            
            // const element = document.getElementById(this.attr.html_id); // this.$refs.attr_container
           
            // const container = this.$refs.attrContainer;
            // const child = document.createElement('div');
            // container.appendChild(child.firstElementChild);
           
            // this.$refs.container.innerHTML = this.attr.innerHTML;
        },
        // Тайл доступен, только если его воркспейс присутствует в processModel_tree
        // и включён птичкой use (админ так помечает настроенные воркспейсы).
        // Иначе клик открывал бы ненастроенный воркспейс — с ошибками/падением.
        _addonRow(addon) {
            const tree = this.WIDGET?.record?.doc?.processModel_tree
            if (!tree) return null
            return this.store.get_field0(tree, addon, 'addon')
        },
        isAvailable(addon) {
            const row = this._addonRow(addon)
            if (!row || row.use === false) return false
            // воркспейс — это attrs[0] (обычно) либо сама addon-нода
            const ws = (row.attrs && row.attrs[0]) ? row.attrs[0] : (row.node?.value ? row : null)
            return !!(ws && ws.use !== false && ws.node?.value)
        },
        onClick(action) {
            // console.log(action)
            // store.executeStoreMethod(vueObj, dblclick_action)

            if (!this.isAvailable(action.addon)) {
                this.store.show_notification({
                    text: this.t('Temporarily unavailable. Contact your administrator.'),   // IE 2026 09 23 / ODOO-341407: i18n (UI-строки — по-английски)
                    status: 'warning',
                })
                return
            }

            let row_addon = this._addonRow(action.addon)
            if (row_addon) {
                if (row_addon.attrs && row_addon.attrs[0]) {
                    const item = row_addon.attrs[0]
                    this.store.workspace_open(item.node.value)
                } else if (row_addon.node?.value) {
                    this.store.workspace_open(row_addon.node.value)
                }
            }
        }
    }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 20px;
    position: relative;
}

.grid-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 20px;
    border-radius: 10px;
    color: white;
    height: 150px;
    transition: transform 0.5s ease-in-out;
}
.grid-item:hover {
    transform: scale(1.03);
}
.grid-item-green { background-color: #45ABB1; }
.grid-item-green2:hover { background-color: #61B8BD; }
.grid-item-blue { background-color: #337ab7; }

/* Ненастроенный воркспейс (нет в processModel_tree или use=false):
   затемняем и гасим hover-эффект, клик показывает попап «временно недоступно». */
.tile-disabled {
    opacity: 0.45;
    filter: grayscale(0.7);
    cursor: not-allowed;
}
.grid-item.tile-disabled:hover {
    transform: none;
}
/* IE 2026 08 21 (заказ Игоря): нечётное число видимых плиток — последняя на всю
   ширину, без пустой ячейки */
.grid-container.tiles-odd .grid-item:not(:has(~ .grid-item)) {
    grid-column: 1 / -1;
}
.center-circle.tile-disabled:hover {
    transform: translate(-50%, -50%);
}
/* IE 2026 08 21 (скрин Игоря): выключенный центр — круг остаётся непрозрачным
   (полупрозрачный пропускал шестерню фона и читался как артефакт), приглушаются
   иконка, подпись и сама шестерня */
.center-circle.tile-disabled {
    opacity: 1;
    filter: none;
    background-color: #f2f3f6;
    color: #9aa0ac;
}
.center-circle.tile-disabled .img-func2 {
    filter: opacity(0.35) grayscale(1);
}
.center-circle.tile-disabled + .img-gear {
    filter: invert(1) opacity(0.45);
}

.center-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 200px;
    background-color: white;
    color: #337ab7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px;
    flex-direction: column;
    transition: transform 0.5s ease-in-out;
    z-index: 2;
}
.img-gear {
    filter: invert(1);
    position: absolute;
    top: 50%;
    left: 50%;
    transition: transform 0.5s ease-in-out;
    height: 260px;
    margin-top: -130px;
    margin-left: -130px;
    z-index: 1;
}
.center-circle:hover {
    transform: translate(-50%, -50%) scale(1.03);
}
.center-circle:hover + .img-gear {
    transform: rotate(5deg) scale(1.03) !important;
}
.logo {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif;
    font-weight: 900 !important;
    /* letter-spacing: -1.5px !important; */
    background: -webkit-linear-gradient(315deg,#42d392 25%,#647eff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
    margin: 5px;
}
.p-logo {
    color: #767676;
}
.img-func {
    height: 70px;
    filter: invert(1);
    margin: 3px;
}
/* IE 2026 09 14 / ODOO-… (заказ Игоря: иконки столов под стили): глиф вместо картинки — белый на цветной плитке, синий в центральном круге */
.img-func-ico { height: 70px; line-height: 70px; font-size: 62px; filter: none; color: white; display: inline-block; }
.img-func2-ico { height: 70px; line-height: 70px; font-size: 62px; filter: none; color: #337ab7; opacity: 0.75; display: inline-block; }
.center-circle.tile-disabled .img-func2-ico { color: #9aa0ac; }
.img-func2 {
    height: 70px;
    filter: opacity(0.6);
    margin: 3px;
}
h2 {
    font-size: calc(1.4rem + 1.8vw);
    font-weight: 900;
}
@media (max-width: 1000px) {
    .grid-container {
        grid-template-columns: 1fr;
    }
    .center-circle {
        width: 180px;
        height: 180px;
    }
    .grid-item {
        flex-direction: row;
        align-items: flex-start;
        text-align: left !important;
        height: 120px;
        justify-content: space-between;
    }
    .grid-item2 {
        align-items: flex-end;
        text-align: right !important;
    }
    .grid-item-center {
        height: 160px;
    }
    h2 {
        font-size: calc(1rem + 1vw);
    }
    .img-gear {
        height: 210px;
        margin-top: -105px;
        margin-left: -105px;
    }
} 
</style>